module.exports = __webpack_public_path__ + "static/media/Guía de autoayuda. Comunidad de Madrid, España, 2014.ec4c5cf1.pdf";